<template>
  <div class="cards-component">
    <div class="area">
      <div class="row cards-container" v-animated-show="utils.handleScroll">
        <div class="row-offset">
          <section
            class="list-section-banner col-5 col-md-12"
            :class="[i % 2 == 0 ? 'gap-offset' : 'gap-inverse-offset']"
            v-for="(l, i) in list"
            :key="i"
            :style="{
              'background-image': 'url(' + l.img.src + ')',
            }"
          >
            <div class="content">
              <a :href="l.href"
                ><Description
                  class="small icon-top icon-top-small centered"
                  ref="bannerDescription"
                  :title="l.title"
                  :desc="l.desc"
                  :list="l.list"
                  :button="l.button"
                  :href="l.href"
                  :icon="l.icon"
                  v-if="l.title"
              /></a>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "Cards",
  props: {
    list: Array,
  },
  data() {
    return { utils: utils };
  },
};
</script>

<style lang="scss">
.cards-component {
  @extend %page-block;
  .row-offset {
    @media all and (max-width: $md) {
      grid-gap: 26px;
    }
  }
  .list-section-banner {
    @media all and (max-width: $md) {
      grid-column: span 6;
    }
    @media all and (max-width: $sm) {
      grid-column: 1 / span 12;
      padding: 45px 20px 280px 20px;
      background-size: auto 280px;
      max-width: 400px;
      justify-self: center;
    }
    @extend %float-shadow;
    border-radius: 20px;
    background-color: $bg-grey-dark;
    padding: 56px 45px;
    min-height: 532px;
    box-sizing: border-box;
    background-size: 100%;
    background-position: center bottom;
    background-repeat: no-repeat;
    .description {
      .description-content {
        .title {
          @media all and (max-width: $md) {
            padding: 0 25px;
          }
        }
        .desc {
          line-height: 1.33em;
        }
        grid-gap: 33px;
      }
      grid-gap: 33px;
    }
    &:nth-child(2n) {
      @media all and (max-width: $md) {
        background-size: auto 320px;
      }
      background-size: 110%;
      background-position: center bottom -30px;
    }
    &:nth-child(2n - 1) {
      @media all and (max-width: $md) {
        margin-right: 0;
      }
      margin-right: 26px;
    }
  }
  .cards-container {
    .row-offset {
      row-gap: 30px;
    }
  }
}
</style>
